import { createPortal } from 'react-dom';
import { Dropdown } from 'react-bootstrap';

type PortalDropdownMenuProps = React.ComponentPropsWithoutRef<typeof Dropdown.Menu>;

const PortalDropdownMenu = ({ children, ...props }: PortalDropdownMenuProps) =>
  createPortal(
    <Dropdown.Menu {...props} popperConfig={{ strategy: 'fixed' }}>
      {children}
    </Dropdown.Menu>,
    document.body
  );

export default PortalDropdownMenu;
